import { useEffect, useRef, useState } from 'react';
import { MapContainer, TileLayer, Marker, Circle, useMapEvents, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix default marker icon (leaflet + webpack issue)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const ClickHandler = ({ onClick }) => {
    useMapEvents({ click: (e) => onClick(e.latlng) });
    return null;
};

const FlyTo = ({ center }) => {
    const map = useMap();
    const prev = useRef(null);
    useEffect(() => {
        if (center && (!prev.current || prev.current[0] !== center[0] || prev.current[1] !== center[1])) {
            map.flyTo(center, map.getZoom(), { duration: 0.5 });
            prev.current = center;
        }
    }, [center, map]);
    return null;
};

const LokasiMapPicker = ({ latitude, longitude, radius, onChange }) => {
    const defaultCenter = [-6.2, 106.8]; // Jakarta fallback
    const lat = parseFloat(latitude);
    const lng = parseFloat(longitude);
    const hasPos = !isNaN(lat) && !isNaN(lng);
    const center = hasPos ? [lat, lng] : defaultCenter;
    const rad = Number(radius) || 100;

    const handleClick = (latlng) => {
        onChange({
            latitude: latlng.lat.toFixed(7),
            longitude: latlng.lng.toFixed(7),
        });
    };

    return (
        <div className="rounded-lg overflow-hidden border border-gray-300" style={{ height: 280 }}>
            <MapContainer
                center={center}
                zoom={hasPos ? 17 : 13}
                style={{ height: '100%', width: '100%' }}
                scrollWheelZoom={true}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <ClickHandler onClick={handleClick} />
                <FlyTo center={hasPos ? center : null} />
                {hasPos && (
                    <>
                        <Marker position={center} />
                        <Circle center={center} radius={rad} pathOptions={{ color: '#1B3C33', fillOpacity: 0.15 }} />
                    </>
                )}
            </MapContainer>
        </div>
    );
};

export default LokasiMapPicker;
